import React, { useState } from "react";
import SearchInputBox from "Components/common/SearchInputBox";

const SEARCH_VISIBLE_THRESHOLD = 8;
const LIMITED_ROWS_COUNT = 2;

const SelectedInboxList = (props = {}) => {
  const {
    inboxes = [],
    loading = false,
    canRemove = true,
    onRemove = () => {},
    showLimit = false,
    inboxUsage = {}
  } = props || {};

  const [showMore, setShowMore] = useState(true);
  const [searchText, setSearchText] = useState("");

  if (loading) {
    return (
      <div className="selectedInboxListV2">
        <ul className="inboxRowList">
          {Array.from({ length: 4 }, (value, index) => (
            <li key={`inboxRowLoader-${index}`} className="linear-background" />
          ))}
        </ul>
      </div>
    );
  }

  if (!inboxes?.length) {
    return <></>;
  }

  const showSearch = !showLimit && inboxes?.length > SEARCH_VISIBLE_THRESHOLD;
  const filteredInboxes =
    showSearch && searchText
      ? inboxes.filter(item =>
          item?.email?.toLowerCase()?.includes(searchText.toLowerCase())
        )
      : inboxes;
  const visibleInboxes =
    showLimit && showMore
      ? filteredInboxes.slice(0, LIMITED_ROWS_COUNT)
      : filteredInboxes;
  const hiddenCount = filteredInboxes.length - LIMITED_ROWS_COUNT;

  return (
    <div className={`selectedInboxListV2 ${showLimit ? "limitedList" : ""}`}>
      {showSearch && (
        <div className="listSearchWrapper">
          <SearchInputBox
            placeholder="Search connected inboxes"
            valueCbk={setSearchText}
            hasCloseIcon={true}
            hasSearchIcon={false}
            hideFocus={true}
          />
        </div>
      )}
      <ul className="inboxRowList">
        {visibleInboxes.map((item = {}) => {
          const usage = inboxUsage?.[item?.id] || {};
          return (
            <li className="inboxRow" key={`selected${item?.id}-${item?.email}`}>
              <span className="rowEmail" title={item?.email}>
                {item?.email}
              </span>
              <span className="rowBadges">
                <span className="statsBadge connectedBadge">
                  {usage?.totalSequences || 0} Connected
                </span>
                <span className="statsBadge activeBadge">
                  {usage?.activeSequences || 0} Active
                </span>
              </span>
              <button
                type="button"
                className={`rowRemoveBtn ${canRemove ? "" : "disabled"}`}
                title={
                  canRemove
                    ? "Remove inbox from sequence"
                    : "At least one inbox must remain connected"
                }
                onClick={
                  canRemove ? () => onRemove(item?.email, item?.id) : () => {}
                }
              >
                <i className="material-icons">close</i>
              </button>
            </li>
          );
        })}
        {showSearch && filteredInboxes.length === 0 && (
          <li className="noResultRow">No inboxes match your search</li>
        )}
      </ul>
      {showLimit && filteredInboxes.length > LIMITED_ROWS_COUNT && (
        <div className="viewMoreBtn" onClick={() => setShowMore(!showMore)}>
          <span>{showMore ? `View ${hiddenCount} more` : "View less"}</span>
          <i className="material-icons arrowDownIcon">
            {showMore ? "keyboard_arrow_down" : "keyboard_arrow_up"}
          </i>
        </div>
      )}
    </div>
  );
};

export default SelectedInboxList;
